import {ActivatedRouteSnapshot} from '@angular/router';

export class AngularUtils {

    /**
     * Transforms the given boolean value to either `true` or `undefined` based on its truthiness.
     * Allows setting the 'disabled' attribute or suppressing it, where disabled="false" is usually
     * still processed as if disabled="true".
     *
     * @param {boolean | undefined} b - The input boolean value or undefined.
     * @return {boolean | undefined} Returns `true` if the input is truthy, otherwise returns `undefined`.
     */
    static trueOrUndefined(b: boolean | undefined): boolean | undefined {
        if (b) return true;
        else return undefined;
    }

    /**
     * Get Angular route parts as Array of strings.
     * https://stackoverflow.com/questions/50250361/how-to-elegantly-get-full-url-from-the-activatedroutesnapshot/50250471
     * @param route
     */
    static getResolvedUrl(route: ActivatedRouteSnapshot): string[] {
        return route.pathFromRoot
            .flatMap(v => v.url.map(segment => segment.toString()));
    }

    static getConfiguredUrl(route: ActivatedRouteSnapshot): string[] {
        return route.pathFromRoot
            .filter(v => v.routeConfig)
            .map(v => v.routeConfig!.path ?? '');
    }
}
